import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "@phosphor-icons/react";

export default function ProgramAdjacentNav({ prev, next }) {
  return (
    <section className="max-w-6xl mx-auto px-4 md:px-8 mt-20 md:mt-28">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <Link
          to={`/programs/${prev.slug}`}
          data-testid="program-prev-link"
          className="group p-6 bg-background border-2 border-border rounded-2xl hover:border-primary/45 hover:-translate-y-0.5 transition-all"
        >
          <div className="eyebrow text-[0.6rem] mb-2 inline-flex items-center gap-2">
            <ArrowLeft size={12} weight="bold" /> Previous program
          </div>
          <div className="font-display text-xl md:text-2xl font-semibold text-primary group-hover:underline">
            {prev.title}
          </div>
        </Link>
        <Link
          to={`/programs/${next.slug}`}
          data-testid="program-next-link"
          className="group p-6 bg-background border-2 border-border rounded-2xl hover:border-primary/45 hover:-translate-y-0.5 transition-all text-right"
        >
          <div className="eyebrow text-[0.6rem] mb-2 inline-flex items-center gap-2">
            Next program <ArrowRight size={12} weight="bold" />
          </div>
          <div className="font-display text-xl md:text-2xl font-semibold text-primary group-hover:underline">
            {next.title}
          </div>
        </Link>
      </div>
    </section>
  );
}
